import {TabState} from 'Navigation';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GenericBackboneViewClass} from 'util/Types';

export enum BufferViewType {
  BACKBONE = 'BACKBONE',
  REACT = 'REACT',
}

export type TabViewWithOptionalAfterAttachCallback = Backbone.View<TabState> & {afterAttach?(): void};

interface BackboneTabViewMetadata {
  TabView: GenericBackboneViewClass<TabState, TabViewWithOptionalAfterAttachCallback>;
  tabViewType: BufferViewType.BACKBONE;
}

export interface ReactTabViewMetadata<TProps extends object> {
  TabView: React.FunctionComponent<TProps> | React.ComponentClass<TProps>;
  tabViewType: BufferViewType.REACT;
  propsFromTabState: (tabState: TabState) => TProps;
  additionalTabClassNames?: string;
}

export type TabViewMetadata = BackboneTabViewMetadata | ReactTabViewMetadata<object>;

interface BackboneOptionsViewMetadata {
  OptionsView: GenericBackboneViewClass<TabState, Backbone.View<TabState>>;
  optionsViewType: BufferViewType.BACKBONE;
}

interface ReactOptionsViewMetadata<TProps extends object> {
  OptionsView: React.FunctionComponent<TProps> | React.ComponentClass<TProps>;
  optionsViewType: BufferViewType.REACT;
  propsFromTabState: (tabState: TabState) => TProps;
}

export type OptionsViewMetadata = BackboneOptionsViewMetadata | ReactOptionsViewMetadata<object>;

export interface BufferViewMetadata {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tabState: {new (options?: any, attributes?: any): TabState};
  tabViewMetadata: TabViewMetadata;
  optionsViewMetadata?: OptionsViewMetadata;
  dataTestAttrs?: DataTestAttrs;
}
